import type { MaybeObservableValue } from '@amazon/vinyl-observable'
import { isTv } from '@/device/deviceConfig'
import { ctx } from '@/util/context'
import { IS_TAURI } from '@/util/platform'

const { errorHandler } = ctx('openExternal')

/**
 * Opens an outside page in a new browser tab. A TV has no browser, so it hands the page to the
 * phone as a QR; the desktop and iOS shells' WKWebView opens no windows, so they hand it to the
 * system browser through the opener plugin.
 */
export function openExternal(url: string, title?: MaybeObservableValue<string>): void {
    if (isTv()) {
        import('@/components/PhoneHandoffModal')
            .then(({ openPhoneHandoff }) => openPhoneHandoff({ title: title ?? url, url }))
            .catch(errorHandler)
    } else if (IS_TAURI) {
        import('@tauri-apps/plugin-opener').then(({ openUrl }) => openUrl(url)).catch(errorHandler)
    } else {
        window.open(url, '_blank', 'noopener,noreferrer')
    }
}
